import { render, staticRenderFns } from "./EditColleagueForm.vue?vue&type=template&id=25f3c683&scoped=true"
import script from "./EditColleagueForm.vue?vue&type=script&lang=js"
export * from "./EditColleagueForm.vue?vue&type=script&lang=js"
import style0 from "./EditColleagueForm.vue?vue&type=style&index=0&id=25f3c683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3c683",
  null
  
)

export default component.exports